// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useEntity } from '../helpers/use-entity'
import { Container } from '@uswitch/ev-core/react'
import UswitchHero from '@uswitch/ev-components/lib/components/elements/hero'

import { cf2imgix } from '../helpers/imgix-image'
import Breadcrumbs from '../breadcrumbs.connected'
import Grid from './grid-from-json.connected'

const ConnectedUswitchHero = (props) => {
  const image = useEntity(props.image)

  const imagePosition = {
    position: {
      backgroundSize: ['auto 90%'],
      backgroundPosition: ['right 0 bottom 0'],
    },
    imageType: 'background',
  }

  const breadcrumbs = <Breadcrumbs entity={props.breadcrumbs} />

  return (
    <UswitchHero
      breadcrumbs={props.breadcrumbs && breadcrumbs}
      container={Container}
      fgImage={cf2imgix(image?.file?.url)}
      fgImagePosition={imagePosition.position}
      fgImageType={imagePosition.imageType}
      fgImageOnMobile={props.displayImageOnMobile}
      variant={props.variant}
    >
      <Grid {...props} />
    </UswitchHero>
  )
}

export default (props) => <ConnectedUswitchHero {...props} />
